import { z } from 'zod';
/**
 * Escenarios de Bre-B que el presentador elige **por compra** en el demo (menú en la app), en lugar de
 * codificarlos en los centavos del monto. Los códigos coinciden con `SANDBOX_MAGIC.breb.amountCents`,
 * que se conserva como convención para pruebas automáticas e integradores. Solo se aceptan con el
 * modo demo activo; en producción el campo se rechaza.
 */
export const DEMO_PAYMENT_SCENARIOS = [
    { code: 'NORMAL', label: 'Compra normal', description: 'El comercio recibe el pago en segundos.' },
    {
        code: 'REJECTED_BY_RECEIVER',
        label: 'Rechazo del banco del comercio',
        description: 'Bre-B rechaza la transferencia (MS03) y se libera el cupo.',
    },
    {
        code: 'NO_CALLBACK_QUERY_ACCEPTED_60S',
        label: 'Bre-B no responde y luego confirma',
        description: 'Sin respuesta; a los 60 s la consulta de estado la confirma.',
    },
    {
        code: 'NO_CALLBACK_QUERY_REJECTED_60S',
        label: 'Bre-B no responde y luego rechaza',
        description: 'Sin respuesta; a los 60 s la consulta de estado la rechaza (AB06).',
    },
    {
        code: 'LATE_CALLBACK_25S',
        label: 'Confirmación tardía',
        description: 'La confirmación de Bre-B llega a los 25 s.',
    },
    {
        code: 'DUPLICATE_CALLBACK',
        label: 'Confirmación duplicada',
        description: 'Bre-B confirma dos veces; se procesa una sola.',
    },
];
export const DemoPaymentScenarioSchema = z
    .enum(DEMO_PAYMENT_SCENARIOS.map((s) => s.code))
    .meta({ id: 'DemoPaymentScenario' });
//# sourceMappingURL=scenarios.js.map